"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var selectors_1 = require("../selectors");
var DataTags = function () {
    var filters = (0, react_redux_1.useSelector)(selectors_1.filtersMapSelector);
    var department = filters.department, category = filters.category, type = filters.type;
    return (react_1.default.createElement("div", { className: "data-tags hidden" },
        react_1.default.createElement("input", { type: "hidden", id: "department", value: department || '' }),
        react_1.default.createElement("input", { type: "hidden", id: "category", value: category || '' }),
        react_1.default.createElement("input", { type: "hidden", id: "type", value: type || '' })));
};
exports.default = DataTags;
